import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  ClearSearchTagOptions,
  GetTagsSuccess,
  SearchPanelStatusChanged,
  SearchTagCodeChanged,
  SearchTagLabelChanged,
  SearchTagTypeChanged,
} from '../actions/search-tags.actions';
import { SearchTagsState } from '../models/search-filters.model';

const initialState: SearchTagsState = {
  panelExpanded: true,
  tagTypeValues: [],
  tagType: '',
  tagCode: '',
  tagLabel: '',
  searchAvailable: false,
};

export const TagManagementReducer = createReducer(
  initialState,
  on(SearchPanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(SearchTagTypeChanged, (state, { tagType }) => ({
    ...state,
    tagType: tagType ?? '',
    searchAvailable: tagType ? true : false,
  })),
  on(SearchTagCodeChanged, (state, { tagCode }) => ({
    ...state,
    tagCode,
  })),
  on(SearchTagLabelChanged, (state, { tagLabel }) => ({
    ...state,
    tagLabel,
  })),
  on(GetTagsSuccess, (state, { res }) => ({
    ...state,
    tagTypeValues: res.payload.data,
  })),
  on(ClearSearchTagOptions, (state) => ({
    ...state,
    tagType: '',
    tagCode: '',
    tagLabel: '',
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    panelExpanded: true,
    tagType: '',
    tagCode: '',
    tagLabel: '',
    searchAvailable: false,
  }))
);
